Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "EmptyState2741467334",
  {"root":"EmptyState2741467334--root","content":"EmptyState2741467334--content","DefaultMarginTop":"100px","MainMarginTop":"--overidable"},
  "",
  1,
  "EmptyState2741467334"
);

